import {SliderReviews} from "../../../common/components/sliderReviews"
import {ReviewsWrapper} from "./style"


export const Reviews = () => {
    return (
        <ReviewsWrapper>
            <SliderReviews/>
        </ReviewsWrapper>
    )

}
